var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_56",
    "data-name": "Group 56",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.508,
    height: 67.818,
    viewBox: "0 0 75.508 67.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 37.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M-1904.572,2418.109h2.552l2.1,11.244,1.981-11.244h2.611l-3.2,15.895h-2.847Z",
    transform: "translate(1904.572 -2417.933)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M-1887.958,2418.109h2.866V2434h-2.866Z",
    transform: "translate(1900.87 -2417.933)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M-1878.59,2418.109h2.021l3.866,9.065v-9.065h2.394V2434h-1.923l-3.886-9.5v9.5h-2.471Z",
    transform: "translate(1898.783 -2417.933)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M-1861.07,2420.248h-2.649v-2.139h8.144v2.139h-2.61V2434h-2.885Z",
    transform: "translate(1895.47 -2417.933)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M-1847.032,2418.109h3.1l3.178,15.895h-2.688l-.627-3.669h-2.767l-.648,3.669h-2.727Zm2.649,10.381-1.079-6.672-1.08,6.672Z",
    transform: "translate(1892.46 -2417.933)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M-1832.859,2432.766a6.977,6.977,0,0,1-.991-4.052v-5.338a6.883,6.883,0,0,1,1.02-4.11,4.082,4.082,0,0,1,3.513-1.384,4.282,4.282,0,0,1,3.375,1.167,5.136,5.136,0,0,1,1.02,3.463v.824h-2.767v-.9a6.885,6.885,0,0,0-.108-1.373,1.317,1.317,0,0,0-.451-.785,1.63,1.63,0,0,0-1.031-.276,1.467,1.467,0,0,0-1.079.354,1.7,1.7,0,0,0-.461.9,7.662,7.662,0,0,0-.108,1.433v6.652a4.372,4.372,0,0,0,.363,2.021,1.41,1.41,0,0,0,1.364.667,1.416,1.416,0,0,0,1.364-.707,4.59,4.59,0,0,0,.382-2.12v-1.491h-1.708v-1.824h4.318v8.064h-1.885l-.2-1.55a2.693,2.693,0,0,1-2.689,1.766A3.694,3.694,0,0,1-1832.859,2432.766Z",
    transform: "translate(1888.815 -2417.882)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M-1816.883,2418.109h6.672v2.041H-1814v4.572h2.983v2.021H-1814v5.278h3.826V2434h-6.711Z",
    transform: "translate(1885.035 -2417.933)",
    fill: "#6b6a7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(13.685 57.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M-1886.258,2453.526a3.454,3.454,0,0,1-.706-2.195l1.506-.3a3.3,3.3,0,0,0,.291,1.394.847.847,0,0,0,.8.481.725.725,0,0,0,.6-.243,1.022,1.022,0,0,0,.2-.658,1.722,1.722,0,0,0-.255-.961,4.669,4.669,0,0,0-.8-.879l-1.209-1.055a3.721,3.721,0,0,1-.836-1.026,2.75,2.75,0,0,1-.28-1.3,2.28,2.28,0,0,1,.665-1.757,2.606,2.606,0,0,1,1.839-.616,2.078,2.078,0,0,1,1.768.706,3.506,3.506,0,0,1,.617,1.9l-1.507.26a3.527,3.527,0,0,0-.208-1.174.659.659,0,0,0-.671-.4.824.824,0,0,0-.634.249.921.921,0,0,0-.232.653,1.447,1.447,0,0,0,.19.771,3.322,3.322,0,0,0,.592.676l1.2,1.056a5.256,5.256,0,0,1,1.055,1.258,2.986,2.986,0,0,1,.379,1.53,2.436,2.436,0,0,1-.3,1.222,2.16,2.16,0,0,1-.849.836,2.544,2.544,0,0,1-1.257.3A2.459,2.459,0,0,1-1886.258,2453.526Z",
    transform: "translate(1886.964 -2444.414)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M-1872.266,2445.844h-1.6v-1.293h4.924v1.293h-1.578v8.317h-1.744Z",
    transform: "translate(1884.046 -2444.445)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M-1859.268,2450.5l-1.946-5.944h1.637l1.187,3.808,1.115-3.808h1.6l-1.921,5.944v3.666h-1.673Z",
    transform: "translate(1881.227 -2444.445)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M-1846.894,2444.551h1.744v8.412h2.337v1.2h-4.081Z",
    transform: "translate(1878.036 -2444.445)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M-1834.362,2444.551h4.034v1.234h-2.29v2.764h1.8v1.222h-1.8v3.192h2.314v1.2h-4.057Z",
    transform: "translate(1875.244 -2444.445)",
    fill: "#6b6a7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M-1829.877,2373.505c-.068-.079-2.838-3.236-11.772-3.065l-.145-.007a30.855,30.855,0,0,0-6.193-.608,25.483,25.483,0,0,0-11.539,2.439l-.068.024a53.3,53.3,0,0,1-7.021.66,53.314,53.314,0,0,1-7.02-.66l-.068-.024a25.481,25.481,0,0,0-11.538-2.439,30.851,30.851,0,0,0-6.193.608l-.145.007c-8.933-.172-11.7,2.986-11.771,3.065a1.709,1.709,0,0,0-.888,1.363c0,.668.557,1.265,1.427,1.658v.006a4.313,4.313,0,0,1,2.069,3.187v.005a32.579,32.579,0,0,0,2.063,10.042l.337.581c1.778,3.92,6.595,6.733,12.262,6.733a14.788,14.788,0,0,0,9.824-3.481c1.494-.9,5.119-4.083,6.181-11.286h0c.318-2.412,1.661-4.247,3.294-4.37.032,0,.063,0,.094,0l.071,0,.072,0a.934.934,0,0,1,.094,0c1.634.123,2.976,1.958,3.294,4.37h0c1.062,7.2,4.687,10.386,6.183,11.286a14.782,14.782,0,0,0,9.821,3.481c5.667,0,10.484-2.813,12.263-6.733l.337-.581a32.6,32.6,0,0,0,2.063-10.042v-.005a4.315,4.315,0,0,1,2.07-3.187v-.006c.87-.393,1.428-.99,1.428-1.658A1.711,1.711,0,0,0-1829.877,2373.505Zm-41.858,4.924c.058,9.333-4.111,13.179-5.66,14.137a12.7,12.7,0,0,1-8.583,3.126c-4.951,0-9.161-2.526-10.714-6.047l-.3-.522a31.324,31.324,0,0,1-1.847-11.677l.335-.924.011-.007c1.167-3.019,6.652-5.306,13.244-5.306,7.441,0,13.473,2.913,13.473,6.506A6.149,6.149,0,0,1-1871.734,2378.429Zm35.495,10.694-.3.522c-1.554,3.521-5.763,6.047-10.715,6.047a12.706,12.706,0,0,1-8.583-3.126c-1.549-.958-5.718-4.8-5.66-14.137a6.524,6.524,0,0,1,.039-.714c0-3.593,6.033-6.506,13.473-6.506,6.592,0,12.078,2.287,13.244,5.306l.012.007.333.924A31.3,31.3,0,0,1-1836.24,2389.124Z",
    transform: "translate(1904.237 -2369.825)",
    fill: "#6b6a7e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo04);
export default __webpack_public_path__ + "static/media/logo04.d4601325c6147b5d07ef7a4513368711.svg";
export { ForwardRef as ReactComponent };